export { default } from './ManageSidePanel'
